/* eslint-disable strict */
"use strict";

import { sendGAPageView, trackOncePerDay } from "../../../foundation/utils/tracking";

sendGAPageView();

trackOncePerDay("Visited app", { Location: "Welcome" });

document.querySelector("#mobileApp a").href = encodeURI("mailto:" + (Zeplin.user ? Zeplin.user.email : "") + "?subject=Zeplin Download Link&" +
    "body=I was going to download Zeplin but I was on my mobile. Then I sent myself this email with the " +
    "download links: \n\n For Mac: https://zpl.io/download-mac \n\n " +
    "For Windows: https://zpl.io/download-windows-64 \n\n " +
    "Technically, I’m talking to myself right now. Is this healthy?");
